import React, { useEffect, useState } from 'react'
import {
  DarkMode,
  Flex,
  FlexProps,
  Select,
  useColorModeValue,
  useMediaQuery,
  Text,
  HStack
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import ReactPaginate from 'react-paginate'
import styled from '@emotion/styled'
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc'

const PaginationContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  ul {
    display: flex;
    .pagination-active {
      background-color: #a4bdbd67;
    }
    .pagination-active:hover {
      background-color: #a4bdbd67;
    }
    .pagination-disabled {
      color: lightgray;
    }
    a {
      padding: 0.4rem 1rem;
      display: inline-flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }
    li {
      flex: 1;
      font-size: 0.75rem;
      font-weight: 900;
      display: flex;
      background-color: ${({ borderColor }) => borderColor};
      border: 0.00000001px solid ${({ borderColor }) => borderColor};
      justify-content: center;
      align-items: center;
      list-style: none;
    }

    li:first-of-type {
      border-radius: 5px 0 0 5px;
    }
    li:last-of-type {
      border-radius: 0 5px 5px 0;
    }
    li:hover {
      background-color: #f3f3f347;
    }
  }
`
export type PaginationProps = {
  setLimit?: React.Dispatch<React.SetStateAction<number>>
  setStart?: React.Dispatch<React.SetStateAction<number>>
  limit?: number
  start?: number
  count?: number | null
} & FlexProps
const Pagination: React.FC<PaginationProps> = ({ count, setStart, limit, setLimit, ...rest }) => {
  const borderColor = useColorModeValue('#EDF2F7', '#2D3748')
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const [pageRangeDisplayed, setPageRangeDisplayed] = useState(10)
  const { t } = useTranslation()
  useEffect(() => {
    setPageRangeDisplayed(() => (isTabletOrMobile ? 0 : 10))
  }, [isTabletOrMobile])

  return (
    <PaginationContainer borderRadius="sm" border="none" borderColor={borderColor} {...rest}>
      <DarkMode>
        {!isTabletOrMobile && (
          <HStack mr={isTabletOrMobile ? 4 : 8}>
            <Select
              onChange={(e) => {
                if (setLimit) setLimit(parseInt(e.target.value))
              }}
              fontWeight="extrabold"
              defaultValue={limit}
              fontSize="xs"
              minW={20}
              width="auto"
            >
              {[5, 10, 20, 50].map((i) => (
                <option key={i} value={i}>
                  {i}
                </option>
              ))}
            </Select>
            <Text fontSize="x-small">
              <i>{t('pagination.entries_per_page')}</i>
            </Text>
          </HStack>
        )}

        <ReactPaginate
          pageCount={count && limit ? Math.ceil(count / limit) : 1}
          initialPage={0}
          disabledClassName="pagination-disabled"
          onPageChange={(value) => {
            if (setStart && limit) setStart(value.selected * limit)
          }}
          activeClassName="pagination-active"
          previousLabel={<VscChevronLeft size={14} />}
          nextLabel={<VscChevronRight size={14} />}
          pageRangeDisplayed={pageRangeDisplayed}
          marginPagesDisplayed={1}
        />
      </DarkMode>
    </PaginationContainer>
  )
}
Pagination.defaultProps = {
  my: 16
}
export default Pagination
